import React from "react";
import whiteLogo from "../../assets/whiteLogo.png";
import { Facebook, Instagram, Twitter } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import img1 from "../../assets/footerimg1.jpg";
import img2 from "../../assets/footerimg2.jpg";
import img3 from "../../assets/footerimg3.jpg";
import img4 from "../../assets/footerimg4.jpg";
import img5 from "../../assets/footerimg5.jpg";

const Footer = () => {
  const images = [img1, img2, img3, img4, img5];
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (
    <div className="">
      <section className="w-full">
        <div className="grid grid-cols-2 md:grid-cols-5">
          {images.map((item, index) => (
            <div
              key={index}
              className={`overflow-hidden ${
                // Hide last image on mobile but show on md+
                index === images.length - 1 ? "hidden md:block" : ""
              }`}
            >
              <img
                src={item}
                alt={`Grid ${index + 1}`}
                className="w-full h-48 md:h-64 object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </section>
      <div className="bg-[#B9A68D] text-center pb-6 pt-12 px-4">
        <p className="text-xl md:text-3xl font-normal text-black favela">
          Where craft meets culture.
          <strong> A chef-led black-tie dinner, done the Marquess Way</strong>
        </p>
      </div>
      <footer className="relative bg-[#1E1815] text-center text-gray-400 overflow-hidden">
        {/* Top wave shape */}
        <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0]">
          <svg
            className="relative block w-full h-[120px]"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M0,40
         C150,80 300,0 450,40
         C600,80 750,0 900,40
         C1050,80 1200,0 1350,40
         L1350,0 L0,0 Z"
              fill="#B9A68D"
            />
          </svg>
        </div>
        {/* Content */}
        <div className="relative flex flex-col items-center justify-center pt-32 pb-6">
          {/* Logo */}
          <img
            src={whiteLogo}
            alt="Marquess Logo"
            className="h-7 md:h-9 mb-6"
          />
          {/* Description */}
          <p className="max-w-lg text-sm md:text-base text-gray-300 mb-8 px-6">
            An intimate evening built around a five-course menu inspired by
            Marquess London’s foundation - West African roots, British
            sensibility, finished with European finesse, brought to life by Chef
            Tandoh, designed for good company and real conversation.
          </p>
          {/* Social icons */}
          <div className="flex gap-6 mb-10 text-gray-300 text-lg">
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/marquesslondon"
                className="hover:text-gray-400 cursor-pointer"
              >
                <Instagram className="h-6 w-6" />
              </a>
              <a
                href="https://www.facebook.com/marquesslondon"
                className="hover:text-gray-400 cursor-pointer"
              >
                <Facebook className="h-6 w-6" />
              </a>
              <a
                href="https://twitter.com/marquesslondon"
                className="hover:text-gray-400 cursor-pointer"
              >
                <Twitter className="h-6 w-6" />
              </a>
            </div>
          </div>
          {/* Navigation */}
          <nav className="w-full bg-[#322823] py-4">
            <ul className="flex flex-wrap justify-center gap-4 md:space-x-10 text-sm">
              <li>
                <p
                  onClick={() => {
                    if (pathname !== "/") {
                      navigate("/", { state: { scrollTo: "home" } });
                    } else {
                      document
                        .getElementById("home")
                        ?.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                  className="text-white hover:text-gray-300 cursor-pointer"
                >
                  Home
                </p>
              </li>

              <li>
                <p
                  onClick={() => {
                    if (pathname !== "/") {
                      navigate("/", { state: { scrollTo: "about" } });
                    } else {
                      document
                        .getElementById("about")
                        ?.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                  className="text-white hover:text-gray-300 cursor-pointer"
                >
                  About
                </p>
              </li>

              <li>
                <p
                  onClick={() => {
                    navigate("/faq", { state: { scrollTo: "about" } });
                  }}
                  className="text-white hover:text-gray-300 cursor-pointer"
                >
                  FAQ
                </p>
              </li>

              <li>
                <a href="mailto:experience@marquesslondon.com">
                  <p className="text-white hover:text-gray-300 cursor-pointer">
                    Contact Us
                  </p>
                </a>
              </li>

              <li>
                <p
                  onClick={() => {
                    if (pathname !== "/") {
                      navigate("/", { state: { scrollTo: "tickets" } });
                    } else {
                      document
                        .getElementById("tickets")
                        ?.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                  className="text-[#B9A68D] hover:text-[#B9A68D] cursor-pointer"
                >
                  Secure Your Seat
                </p>
              </li>
            </ul>
          </nav>
          {/* Copyright */}
          <p className="mt-6 text-xs text-gray-400">
            <span>
              © {new Date().getFullYear()} MARQUESS LONDON. All rights
              reserved.
            </span>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
